var map = {
	"./Group 10.svg": 512,
	"./Icon ionic-ios-chatbubbles.svg": 5801,
	"./Path 1182.svg": 2360,
	"./Path 412.svg": 1854,
	"./avatar.svg": 5515,
	"./back arrow.svg": 7382,
	"./branch.svg": 3962,
	"./carbonreport.svg": 2434,
	"./cash.svg": 6052,
	"./cash_credit.svg": 481,
	"./cashier.svg": 9460,
	"./cashierBG.png": 7806,
	"./check.svg": 8726,
	"./circle.svg": 1361,
	"./clear.svg": 315,
	"./clearAll.svg": 5069,
	"./credit.svg": 1016,
	"./customer-service-svgrepo-com.svg": 2135,
	"./customer_avatar.svg": 3321,
	"./edit-files-white.svg": 9698,
	"./edit-files.svg": 4730,
	"./endSheeft.svg": 2839,
	"./error404.svg": 5306,
	"./expenses.svg": 8635,
	"./eye-svgrepo-com.svg": 8794,
	"./full-report.svg": 3726,
	"./home.svg": 2769,
	"./img.svg": 4205,
	"./incorrect.svg": 1045,
	"./keyboard-svgrepo-com.svg": 3938,
	"./loading.gif": 6333,
	"./logo0.svg": 232,
	"./logo1.svg": 7737,
	"./logo2.svg": 6592,
	"./logo3.svg": 7354,
	"./logout.svg": 5908,
	"./menu.svg": 7995,
	"./msg.png": 4327,
	"./network.svg": 7570,
	"./no_data.svg": 5616,
	"./nothing.svg": 4473,
	"./notice-creditor.svg": 7576,
	"./notice-debtor.svg": 9077,
	"./notice.svg": 6347,
	"./orders-menu.svg": 2833,
	"./orders.svg": 9017,
	"./pending_orders.svg": 5825,
	"./pending_orders_menu.svg": 8321,
	"./pending_request.svg": 8214,
	"./placeholder.gif": 4365,
	"./purchase.svg": 6395,
	"./reports.svg": 6518,
	"./sales-report.svg": 2590,
	"./sales.svg": 6802,
	"./scissors.svg": 9044,
	"./shift.svg": 5219,
	"./support.svg": 3981,
	"./supportSys.svg": 8598,
	"./supportSysG.png": 2808,
	"./treasury.png": 4119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4181;